module.exports = __webpack_public_path__ + "img/userLogo18.3bb0b142.jpg";